module.exports = __webpack_public_path__ + "static/media/KEKW.cbf78702.jpg";